import React from "react";

export const EventName = (props) => {
  const { eventName, settings } = props;

  return <span style={settings}>{eventName}</span>;
};
